"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirportNoise$ = exports.AirportNoise$outboundSchema = exports.AirportNoise$inboundSchema = void 0;
exports.airportNoiseToJSON = airportNoiseToJSON;
exports.airportNoiseFromJSON = airportNoiseFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
const airportnoisecategories_js_1 = require("./airportnoisecategories.js");
/** @internal */
exports.AirportNoise$inboundSchema = z.object({
    area: z.string(),
    assessment: z.string(),
    assessment_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    category: airportnoisecategories_js_1.AirportNoiseCategories$inboundSchema,
    description: z.string(),
    level: z.number(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "assessment_date": "assessmentDate",
    });
});
/** @internal */
exports.AirportNoise$outboundSchema = z.object({
    area: z.string(),
    assessment: z.string(),
    assessmentDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    category: airportnoisecategories_js_1.AirportNoiseCategories$outboundSchema,
    description: z.string(),
    level: z.number(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        assessmentDate: "assessment_date",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AirportNoise$;
(function (AirportNoise$) {
    /** @deprecated use `AirportNoise$inboundSchema` instead. */
    AirportNoise$.inboundSchema = exports.AirportNoise$inboundSchema;
    /** @deprecated use `AirportNoise$outboundSchema` instead. */
    AirportNoise$.outboundSchema = exports.AirportNoise$outboundSchema;
})(AirportNoise$ || (exports.AirportNoise$ = AirportNoise$ = {}));
function airportNoiseToJSON(airportNoise) {
    return JSON.stringify(exports.AirportNoise$outboundSchema.parse(airportNoise));
}
function airportNoiseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AirportNoise$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AirportNoise' from JSON`);
}
//# sourceMappingURL=airportnoise.js.map